export default {
  red: {
    thunderbird: '#d11313',
    newYorkPink: '#d17d7d',
  },
  orange: {
    piazazz: '#fb8c00',
  },
  blue: {
    default: '#0000FF',
    picton: '#14adeb',
  },
  green: {
    vidaLoca: '#60ae20',
  },
  grey: {
    alto: '#dddddd',
    doveGray: '#6e6e6e',
  },
  black: {
    default: 'rgba(17,17,17,0.4)',
    almost: '#111111'
  },
  yellow: {
    dolly: '#fffb82',
  },
  purple: {
    lavender: '#967bb6'
  }
};
